import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// import Grid from '@material-ui/core/Grid';
import moment from 'moment-timezone';

import DataForm from 'forms/DataForm';
import { request } from 'utilities/graph';
import { getOrder } from 'graphql/queries';
import { adminUpdateOrder } from 'graphql/mutations';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import cache from 'utilities/cache';
// import Directions from 'components/Map/Directions';

import uiSchema from './AdminUpdateOrderForm.uiSchema';
import { TIME_ZONE } from '@silvergatedelivery/constants';

const defaultFormData = {};

export default function AdminUpdateOrderForm({ formData: inFormData, ...props }) {
  const { t } = useTranslation();
  // load here for translation purpose
  const { default: schema } = require('./AdminUpdateOrderForm.schema.js');
  const formData = (inFormData || defaultFormData);
  if (!formData.deliveryStaffId) delete formData.deliveryStaffId;

  const username = cache.get('app:username');
  const defaultDiary = `${username}將訂單標示為已完成`;

  const [deliveryBy, setDeliveryBy] = useState(formData.deliveryBy);
  const [dirty, setDirty] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showDiaryDialog, setShowDiaryDialog] = useState(false);
  const [diary, setDiary] = useState(defaultDiary);
  const [pendingUpdateData, setPendingUpdateData] = useState(null);
  // const [directionKey, setDirectionKey] = useState();
  // const [startAddress, setSartAddress] = useState();
  // const [endAddress, setEndAddress] = useState();

  const createFunc = async () => {};

  const handleDiarySubmit = async () => {
    setIsLoading(true);

    const toUpdateData = {
      ...pendingUpdateData,
      diary,
    };

    try {
      await request(adminUpdateOrder, { input: { orders: [toUpdateData] } });
    } catch (e) {
      console.log(e);
    }

    const { data: { getOrder: order } } = await request(getOrder, { id: pendingUpdateData.id });
    setIsLoading(false);
    setShowDiaryDialog(false);
    setDiary(defaultDiary);
    setPendingUpdateData(null);

    // Call onComplete callback if provided
    if (props.onComplete) {
      props.onComplete(order);
    }

    return order;
  };

  const handleDiaryClose = () => {
    setShowDiaryDialog(false);
    setDiary(defaultDiary);
    setPendingUpdateData(null);
  };

  const updateFunc = async (data) => {
    setIsLoading(true);

    const isReassigningStatus = ['waitingForDeliveryStaff', 'reMatchingDeliveryStaff'].includes(data.status);
    const status = data.deliveryStaffId && isReassigningStatus ? 'ready' : data.status;

    // 預處理 mealItems，確保每筆有 surcharges
    const normalizedMealItems = (data.mealItems || []).map((item) => ({
      ...item,
      surcharges: item.surcharges || [],
    }));

    const calculateTotal = (field) =>
      normalizedMealItems.reduce((sum, item) => sum + item[field] * item.quantity, 0);

    const toUpdateData = {
      id: data.id,
      restaurantId: data.restaurantId,
      deliveryBy,
      status,
      deliveryStaffId: data.deliveryStaffId,
      deliveryStaffFee: data.deliveryStaffFee || 0,
      tier: data.tier,
      noteForDelivery: data.noteForDelivery,
      noteForMeal: data.noteForMeal,
      note: data.note,
      mealItems: normalizedMealItems,
      total: calculateTotal('price'),
      totalCost: calculateTotal('cost'),
      category: data.category,
      cancellationReason: data.cancellationReason,
      cancellationNote: data.cancellationNote,
    };

    // 若狀態要改為 completed，且原本不是，就進入 diary dialog 邏輯
    const isChangingToCompleted = status === 'completed' && formData.status !== 'completed';
    if (isChangingToCompleted && data.deliveryStaffId) {
      setPendingUpdateData(toUpdateData);
      setShowDiaryDialog(true);
      setIsLoading(false);
      throw new Error('DIARY_DIALOG_SHOWN');
    }

    global.logger.debug({ data, toUpdateData });

    try {
      await request(adminUpdateOrder, { input: { orders: [toUpdateData] } });
      const { data: { getOrder: order } } = await request(getOrder, { id: data.id });
      return order;
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   if (directionKey) {
  //     const [restaurantId, elderId] = directionKey.split('__');
  //     (async () => {
  //       const [
  //         { data: { getRestaurant: restaurant } },
  //         { data: { getElder: elder } },
  //       ] = await Promise.all([
  //         request(getRestaurant, { id: restaurantId }),
  //         request(getElder, { id: elderId }),
  //       ]);

  //       setSartAddress(restaurant.address);
  //       setEndAddress(elder.address);
  //     })();
  //   }
  // }, [directionKey]);

  return (
    <React.Fragment>
      {deliveryBy &&
      <TextField
        id="deliveryBy"
        label={`${t('送餐')}時間`}
        type="datetime-local" // format 2017-05-24T10:30
        value={moment(deliveryBy).tz(TIME_ZONE).format('YYYY-MM-DDTHH:mm')}
        disabled={
          isLoading ||
          ['readyForPickup', 'delivering', 'delivered', 'completed', 'cancelled'].includes(formData.status)
        }
        InputLabelProps={{
          shrink: true,
        }}
        onChange={(e) => {
          const updatedDatetime = moment.tz(e.target.value, TIME_ZONE).toISOString();
          if (updatedDatetime) {
            setDeliveryBy(updatedDatetime);
            setDirty(true);
          }
        }}
      />}
      <DataForm
        schema={schema}
        uiSchema={uiSchema}
        createFunc={createFunc}
        updateFunc={updateFunc}
        formData={formData}
        dirty={dirty}
        {...props}
      >
        {/* <Directions startAddress={startAddress} endAddress={endAddress}/> */}
      </DataForm>
      <Dialog
        maxWidth='sm'
        fullWidth
        open={showDiaryDialog}
        onClose={(e, reason)=>{
          if (reason === 'escapeKeyDown' || reason === 'backdropClick') return;
          handleDiaryClose();
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {!isLoading ? t('送餐關懷') : '更新訂單中'}
        </DialogTitle>
        <DialogContent style={{ marginBottom: 30 }}>
          {!isLoading ?
            <TextField
              margin="dense"
              id="diary"
              label="日誌"
              type="text"
              value={diary}
              fullWidth
              required
              multiline={true}
              minRows={5}
              onChange={(e) => setDiary(e.target.value) }
              style={{ width: 360 }}
            /> :
            <div>更新中...</div>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDiaryClose} color="default" disabled={isLoading}>
            取消
          </Button>
          <Button onClick={handleDiarySubmit} color="primary" variant="contained" disabled={isLoading || !diary}>
            更新
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

AdminUpdateOrderForm.propTypes = {
  formData: PropTypes.object,
  onComplete: PropTypes.func,
};
